import { createSlice } from '@reduxjs/toolkit';

const ticTacToeSlice = createSlice({
  name: 'ticTacToe',
  initialState: {
    board: Array(9).fill(null),
    currentTurn: null,
    winner: null,
    marks: {},   // { playerId: 'X'|'O' }
  },
  reducers: {
    updateTTT(state, action) {
      const { board, currentTurn, winner, marks } = action.payload;
      state.board = board;
      state.currentTurn = currentTurn;
      state.winner = winner;
      state.marks = marks;
    },
    resetTTT(state) {
      state.board = Array(9).fill(null);
      state.currentTurn = null;
      state.winner = null;
      state.marks = {};
    },
  },
});

export const { updateTTT, resetTTT } = ticTacToeSlice.actions;
export default ticTacToeSlice.reducer;
